import { Alert, styled } from '@mui/material';

export const UIAlert = styled(Alert)({
  width: '100%',
  whiteSpace: 'pre-wrap',
  background: '#2F312D',
  color: '#fff',
});
